import type { CoreShellPorts } from '../../../../../routing/domain/CoreShellPorts.ts';

/** Logs out with telemetry/toast on failure and redirects to login. */
export async function runLayoutLogoutAndRedirect(
  shellPorts: Pick<CoreShellPorts, 'auth' | 'telemetry' | 'notifications'>,
  loginPath: string = '/login',
): Promise<void> {
  try {
    await shellPorts.auth.logout();
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    shellPorts.telemetry.logError(msg, { source: 'layout.logout', error: e });
    shellPorts.notifications.warning('Cierre de sesión incompleto; se redirige al login.');
  }
  globalThis.location.replace(loginPath);
}
